<template>
  <div class="light">
    <div class="header">
      <div class="title">空调设备列表</div>
      <div class="fast-btn">
        <dtit-button :is-cover="groupInfo['isCovers']" :state="groupInfo['state']" class="addgroup" :text="groupInfo['text']" :type="groupInfo['type']" :is-cancel="groupInfo['isCancel']" :icon-url="groupInfo['iconUrl']" @change="group" @cancel="cancel" @save="save"/>
        <my-button :state="state" @change="powerSwitch" v-if="groupInfo['iconUrl']"></my-button>
        <el-dropdown type="primary" @command="changeMode" trigger="click" v-if="groupInfo['iconUrl']">
          <el-button type="primary">
            模式调节<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(mode,i) in modeArray" :command="mode.value"
                              v-text="mode.name"
                              :key="`mode_${i}`"></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown type="primary" @command="changeWind" trigger="click" v-if="groupInfo['iconUrl']">
          <el-button type="primary">
            风速调节<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(wind,i) in windArray" :command="wind.value"
                              v-text="wind.name"
                              :key="`wind_${i}`"></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="container">
      <div class="group-device"  v-for="(d,i) in extDevices" :key="`air_d_${i}`"  v-show="d.devicetype.key==='aircon'">
        <air-condition :device="d" ></air-condition>
        <div class="group-edit" v-if="isCover"></div>
        <div class="group-checkbox" v-if="isCover" :class="{checked: d.checked, unchecked: !d.checked}" @click="choose(d, i)"></div>
      </div>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import AirCondition from '@/components/Aircon'
import Round from '@/components/Round'
import MyButton from '@/components/Button'
import DtitButton from '@/components/DtitButton'
import { mapState, mapActions } from 'vuex'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  name: 'DeviceAir',
  data () {
    return {
      modeArray: [
        {
          'name': '制冷',
          'value': 0
        }, {
          'name': '制热',
          'value': 1
        }],
      windArray: [
        {
          'name': '低风',
          'value': 1
        }, {
          'name': '中风',
          'value': 2
        }, {
          'name': '高风',
          'value': 3
        }],
      isCover: false,
      groupInfo: {
        text: '添加群控',
        type: 'aircon',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      },
      name: '',
      index: '',
      desc: ''
    }
  },
  provide () {
    return {
      all: this
    }
  },
  computed: {
    ...mapState(['extDevices', 'groups']),
    state () {
      return this.extDevices.filter(e => e.devicetype.key === 'aircon').every(l => l.state.state)
    }
  },
  components: {
    MyButton,
    AirCondition,
    Round,
    DtitButton
  },
  methods: {
    ...mapActions(['updateGroups']),
    async powerSwitch () {
      try {
        await api.batchControl(['aircon'], this.state ? 'close' : 'open')
        // this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeWind (value) {
      try {
        await api.batchControl(['aircon'], value === 1 ? 'low' : value === 2 ? 'medium' : 'high')
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeMode (value) {
      try {
        await api.batchControl(['aircon'], value === 1 ? 'warm' : 'cool')
      } catch (e) {
        Message.error(e.message)
      }
    },
    // 群组功能
    group () {
      if (!this.groupInfo['state']) {
        this.isCover = true
        this.groupInfo = {
          text: '保存',
          type: 'aircon',
          iconUrl: '',
          state: false,
          isCancel: true,
          isCovers: false
        }
      }
      // 保存选中的设备
      if (this.groupInfo['state']) {

      }
    },
    // 取消
    cancel () {
      this.isCover = false
      this.groupInfo = {
        text: '添加群控',
        type: 'aircon',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      }
      this.extDevices.forEach((item, index) => {
        item.checked = false
        this.$set(this.extDevices, index, item)
      })
      this.name = ''
      this.desc = ''
      this.index = ''
    },
    // 选中分组设备
    choose (item, index) {
      item.checked = !item.checked
      this.$set(this.extDevices, index, item)
      // 检查是否又被选中的设备
      const isChecked = this.extDevices.some(item => item.checked)
      this.groupInfo['state'] = isChecked
    },
    // 保存组
    async save (data) {
      let listId = this.extDevices.filter(item => item.checked).map(item => item.id)
      // 如果是修改
      if (this.groupInfo.isCovers) {
        this.groups[this.index]['name'] = data.name
        this.groups[this.index]['remark'] = data.desc
        let result = await this.updateGroups(this.groups)
        if (result && result.code === 1) {
          Message.success('修改成功！')
        } else {
          Message.warning('修改失败！')
        }
      } else {
        let result = await this.updateGroups({ name: data.name, remark: data.desc, key: 'aircon', listId })
        if (result && result.code === 1) {
          Message.success('添加成功！')
        } else {
          Message.warning('添加失败！')
        }
      }
    }
  },
  activated () {
    // 处理修改组控
    if (this.$route.params && this.$route.params['include']) {
      this.name = this.$route.params['name']
      this.index = this.$route.params['index']
      this.desc = this.$route.params['desc']
      this.isCover = true
      this.groupInfo = {
        text: '保存',
        type: 'aircon',
        iconUrl: '',
        state: true,
        isCancel: true,
        isCovers: true
      }
      // 判断选中
      this.extDevices.forEach((item, index) => {
        if (this.$route.params['include'].includes(item.id)) {
          item.checked = true
          this.$set(this.extDevices, index, item)
        }
      })
    } else {
      this.cancel()
    }
  },
  mounted () {
    this.cancel()
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";

.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
        > .group-device {
      position: relative;
      box-sizing: border-box;
      height: 260px;
      min-width: 230px;
      max-width: 24%;
      .group-edit {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.2;
      }
      .group-checkbox {
        position: absolute;
        bottom: 24px;
        right: 24px;
        width: 30px;
        height: 30px;
        z-index: 1;
      }
      .unchecked {
          background: url('../../assets/images/group/unchecked.png') no-repeat center;
          background-size:cover;
      }
      .checked {
          background: url('../../assets/images/group/checked.png') no-repeat center;
          background-size:cover;
      }
    }
  }
}
</style>
